import React from "react";
import ListItemText from "@mui/material/ListItemText";
import { useGameNames, useMyProfile } from "@seabrookstudios/pitch2table";
import {
  formatSessionDate,
  formatSessionDuration,
  formatSessionTime,
  SessionTypeLabels,
} from "@seabrookstudios/pitch2table-core";
import ListItemButton from "@mui/material/ListItemButton";
import { Path } from "../Path";
import { useNavigate } from "react-router-dom";
import ListItemIcon from "@mui/material/ListItemIcon";
import AccessTime from "@mui/icons-material/AccessTime";
import { usePublisherNames } from "../publisher/queries";

/**
 * Session list item component
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").Session} props.session
 * @param {import("@seabrookstudios/pitch2table-core").CalendarEvent} props.convention
 */
export const SessionListItem = ({ session, convention }) => {
  const { data: profile } = useMyProfile();
  const publishers = usePublisherNames(session.publisherIds);

  const navigate = useNavigate();

  const preferredTimezone = convention.type === "VirtualConvention" ? profile?.location?.timezone : convention.timezone;
  const timeDisplay = formatSessionTime(session, convention, preferredTimezone);
  const durationDisplay = formatSessionDuration(session);

  const publishersDisplay = publishers.join(", ");

  const title = `${SessionTypeLabels[session.type]}${publishersDisplay ? ` with ${publishersDisplay}` : ""}`;

  const description = durationDisplay ? `${timeDisplay} • ${durationDisplay}` : timeDisplay;

  const openSession = () => {
    navigate(Path.session(session.id));
  };

  return (
    <ListItemButton onClick={openSession}>
      <ListItemText primary={title} secondary={description} />
    </ListItemButton>
  );
};
/**
 * Session list item component
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").Session} props.session
 */
export const SessionListItemNoConvention = ({ session }) => {
  const { data: profile } = useMyProfile();
  const navigate = useNavigate();
  const games = useGameNames(session.gameIds);

  const openSession = () => {
    navigate(Path.session(session.id));
  };

  return (
    <ListItemButton onClick={openSession}>
      <ListItemIcon>
        <AccessTime />
      </ListItemIcon>
      <ListItemText
        primary={formatSessionDate(session.date, profile?.location?.timezone)}
        secondary={games.join(", ")}
      />
    </ListItemButton>
  );
};
